import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	validationMessageBeforeGreaterThanAfter: {
		id: `eoc.alert-list.common.utils.validation-message-before-greater-than-after.no-translate`,
		defaultMessage: "'Before' field cannot be later than 'After' field.",
		description:
			'Message displayed to the user when the Before date used is greater than the after date while specifying dates',
	},
	validationMessageInvalidDateFormat: {
		id: `eoc.alert-list.common.utils.validation-message-invalid-date-format.no-translate`,
		defaultMessage: 'Invalid date format.',
		description: 'Invalid date format.',
	},
	validNumber: {
		id: `eoc.alert-list.common.utils.validation-not-number.no-translate`,
		defaultMessage: 'Enter a valid number.',
		description:
			'The error message that shown when user write different chars other than numeric chars.',
	},
	hoursNotInRange: {
		id: `eoc.alert-list.common.utils.validation-message-hours-not-in-range.no-translate`,
		defaultMessage: 'Enter a number between 1-99999.',
		description: 'Message displayed to the user when hours value is not in range',
	},
	daysNotInRange: {
		id: `eoc.alert-list.common.utils.validation-message-days-not-in-range.no-translate`,
		defaultMessage: 'Enter a number between 1-9999.',
		description: 'Message displayed to the user when days value is not in range',
	},
	weeksNotInRange: {
		id: `eoc.alert-list.common.utils.validation-message-weeks-not-in-range.no-translate`,
		defaultMessage: 'Enter a number between 1-999.',
		description: 'Message displayed to the user when weeks value is not in range',
	},
	monthsNotInRange: {
		id: `eoc.alert-list.common.utils.validation-message-months-not-in-range.no-translate`,
		defaultMessage: 'Enter a number between 1-99.',
		description: 'Message displayed to the user when months value is not in range',
	},
	yearsNotInRange: {
		id: `eoc.alert-list.common.utils.validation-message-years-not-in-range.no-translate`,
		defaultMessage: 'Enter a number between 1-9.',
		description: 'Message displayed to the user when years value is not in range',
	},
});

export default messages;
